import React, {useCallback, useState} from 'react'
import Popover from '@material-ui/core/Popover'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import {MaterialUiPickersDate} from '@material-ui/pickers/typings/date'
import LocalizedDateTimePicker from 'lib/LocalizedDateTimePicker'
import {ISO_MINUTE_FORMAT, browserTimezone} from 'lib/date-time'
import moment from 'moment-timezone'

type CustomDateTimePopoverProps = {
  anchorEl: HTMLElement | null
  onClose: () => void
  onSubmit: (variable: string) => void
}

export default function CustomDateTimePopover({
  anchorEl,
  onClose,
  onSubmit,
}: CustomDateTimePopoverProps) {
  const [date, setDate] = useState<MaterialUiPickersDate>(null)
  const [showInUserTimezone, setShowInUserTimezone] = useState(false)

  const open = Boolean(anchorEl)
  const pickerTimezone = moment().tz() ?? browserTimezone()
  const dateLabel = `Date & Time (${pickerTimezone})`

  const handleClose = useCallback(() => {
    setDate(null)
    setShowInUserTimezone(false)
    onClose()
  }, [onClose])

  const handleSubmit = useCallback(() => {
    if (!date) {
      return
    }
    onSubmit(
      `{{custom_date_time|${date.format(ISO_MINUTE_FORMAT)}|${
        showInUserTimezone ? 1 : 0
      }}}`,
    )
    setDate(null)
    setShowInUserTimezone(false)
  }, [date, showInUserTimezone, onSubmit])

  return (
    <Popover
      open={open}
      anchorEl={anchorEl}
      onClose={handleClose}
      anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
      transformOrigin={{vertical: 'top', horizontal: 'left'}}
      disableRestoreFocus
    >
      <div className="html-editor-popover">
        <div className="html-editor-popover__label">Custom Date/Time</div>
        <LocalizedDateTimePicker
          label={dateLabel}
          value={date}
          onChange={setDate}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={showInUserTimezone}
              onChange={(e) => setShowInUserTimezone(e.target.checked)}
              color="primary"
              size="small"
            />
          }
          label="Show in each viewer's time zone"
        />
        <div className="html-editor-popover__actions">
          <button
            className="html-editor-popover__btn html-editor-popover__btn--confirm"
            onClick={handleSubmit}
            type="button"
            disabled={!date}
          >
            ✓
          </button>
          <button
            className="html-editor-popover__btn html-editor-popover__btn--cancel"
            onClick={handleClose}
            type="button"
          >
            ✕
          </button>
        </div>
      </div>
    </Popover>
  )
}
